import { ReactNode } from 'react';
import {
  SxProps,
  TableRow as MUITableRow,
  TableRowProps as MUITableRowProps,
} from '@mui/material';

import colors from '@atom/styles/colors';

type CustomProps = {
  /**
   * Denotes row is being used as a table header.
   */
  header?: boolean;
  /**
   * Determines the height of the row.
   * Defaults to none.
   */
  height?: string;
  /**
   * Determines the background color of the row.
   * Defaults to white.
   */
  backgroundColor?: string;
  /**
   * Determines the hover color.
   * Defaults to 'auto' (gray).
   * Dom prop collision with camelCased hoverColor
   */
  hovercolor?: string;
};

type AtomMUIProps = {
  hover?: boolean;
  children?: ReactNode;
  onClick?: () => void;
};

export type TableRowProps = CustomProps & AtomMUIProps;

const TableRow = (props: TableRowProps) => {
  const {
    hover: hoverProp,
    header,
    height = 'none',
    backgroundColor = colors.neutral.white,
    hovercolor = 'auto',
    ...data
  } = props;

  const hover = hoverProp ?? !header;

  const sx: SxProps = {
    height,
    backgroundColor,
    '&.MuiTableRow-hover:hover': {
      backgroundColor: `${hovercolor} !important`,
    },
  };

  return <MUITableRow hover={hover} {...(data as MUITableRowProps)} sx={sx} />;
};

export default TableRow;
